// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"becbada2","126":"4c45cb67","129":"746ce150","197":"54828ea5","725":"89628289","883":"6bc808e2","992":"0879da79"}[chunkId] + ".chunk.js";
};